module.exports = __webpack_public_path__ + "static/img/lineup_cmt_j_wildberry.33fa40e.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/lineup_cmt_j_wildberry.svg
// module id = 5QpJ
// module chunks = 1